import {i18n} from "./lang/vue-i18n";
var util = {
  //api: "http://commodity.cardhobby.cn",
  Test: {
    User: {
      Id: 3,
      NickName: "KingPan",
      HeadPortrait: "",
      IsSeller: false,
      Status: 0,
      Language: "en",
      MappingUserId: 57147,
      ChineseToken: "a9ec62fe837afa981a051e50818a89c9"
    }
  },
  PropertyList: [
    /*
     * 分类浏览选项列表
     * 篮球、 橄榄球、 棒球 、冰球、足球、 UFC 、WWE、F1 、Other Sports（其他运动）、宝可梦、Gaming（其他游戏）、娱乐（entertainment）*/
    {
      Id: "175af7b5-d6bc-4d44-b913-9f8da05e3288",
      ChName: "篮球",
      EnName: "Basketball",
      KeyType: "Sports",
      key: 1,
      index: "0-0-0",
      FId: "dee8e93d-bf0d-46d7-a817-45db58756940",
      SId: "4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de",
      TId: "10106fda-c5d8-4121-ab21-0428534eaf42"
    },
    {
      Id: "e6fd3abb-ac0f-4537-8712-6417e9c23a25",
      ChName: "橄榄球",
      EnName: "Football",
      KeyType: "Sports",
      key: 2,
      index: "0-0-0",
      FId: "dee8e93d-bf0d-46d7-a817-45db58756940",
      SId: "4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de",
      TId: "10106fda-c5d8-4121-ab21-0428534eaf42"
    },
    {
      Id: "a92bc03d-8400-4362-9142-0fef2b2b02a2",
      ChName: "棒球",
      EnName: "Baseball",
      KeyType: "Sports",
      key: 3,
      index: "0-0-0",
      FId: "dee8e93d-bf0d-46d7-a817-45db58756940",
      SId: "4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de",
      TId: "10106fda-c5d8-4121-ab21-0428534eaf42"
    },
    {
      Id: "57e242de-4e1f-47b0-8056-3ef1c0931488",
      ChName: "冰球",
      EnName: "Hockey",
      KeyType: "Sports",
      key: 4,
      index: "0-0-0",
      FId: "dee8e93d-bf0d-46d7-a817-45db58756940",
      SId: "4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de",
      TId: "10106fda-c5d8-4121-ab21-0428534eaf42"
    },
    {
      Id: "5efa4eb7-c519-403c-88e0-51a4b76cbd1e",
      ChName: "足球",
      EnName: "Soccer",
      KeyType: "Sports",
      key: 5,
      index: "0-0-0",
      FId: "dee8e93d-bf0d-46d7-a817-45db58756940",
      SId: "4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de",
      TId: "10106fda-c5d8-4121-ab21-0428534eaf42"
    },
    {
      Id: "9be61af5-9e00-4cb0-af99-d96b1b37bc4d",
      ChName: "UFC/MMA",
      EnName: "UFC/MMA",
      OtherName: "综合格斗",
      KeyType: "Sports",
      key: 6,
      index: "0-0-0",
      FId: "dee8e93d-bf0d-46d7-a817-45db58756940",
      SId: "4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de",
      TId: "10106fda-c5d8-4121-ab21-0428534eaf42"
    }, //终极格斗
    {
      Id: "86083b79-7a63-4bd7-abff-b8c75ca85a3c",
      ChName: "WWE",
      EnName: "WWE",
      OtherName: "美式摔跤",
      KeyType: "Sports",
      key: 7,
      index: "0-0-0",
      FId: "dee8e93d-bf0d-46d7-a817-45db58756940",
      SId: "4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de",
      TId: "10106fda-c5d8-4121-ab21-0428534eaf42"
    },
    {
      Id: "7529cfb1-5a44-4e55-9de1-453b78dbaf3e",
      ChName: "F1",
      EnName: "F1",
      OtherName: "一级方程式锦标赛",
      KeyType: "Sports",
      key: 8,
      index: "0-0-0",
      FId: "dee8e93d-bf0d-46d7-a817-45db58756940",
      SId: "4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de",
      TId: "10106fda-c5d8-4121-ab21-0428534eaf42"
    }, //一级方程式锦标赛
    //{ 'Id': '', 'ChName': '其他运动', 'EnName': 'Other Sports', 'KeyType': 'OtherType', 'OtherKeyType': 'Sports', 'val': 'Golf，Tennis', 'key': 9, 'FId': '', 'SId': '', 'TId': '10106fda-c5d8-4121-ab21-0428534eaf42' },
    {
      Id: "1aa8fa18-4c5b-47cc-8e03-acf2073dd5e4",
      ChName: "宝可梦",
      EnName: "Pokemon",
      KeyType: "GameComic",
      key: 10,
      index: "0-2-0",
      FId: "dee8e93d-bf0d-46d7-a817-45db58756940",
      SId: "55b61752-b4b2-4437-8eba-a9f21cc14b6f",
      TId: "2794188f-92c7-4c8b-bf7b-019e8bb07e8b"
    },
    {
      Id: "",
      ChName: "游戏王",
      EnName: "Yu-Gi-Oh! OCG",
      KeyType: "GameComic",
      key: 10,
      index: "0-2-0",
      FId: "dee8e93d-bf0d-46d7-a817-45db58756940",
      SId: "55b61752-b4b2-4437-8eba-a9f21cc14b6f",
      TId: "2794188f-92c7-4c8b-bf7b-019e8bb07e8b"
    },
    //{ 'Id': '', 'ChName': '其他游戏', 'EnName': 'Pokemon', 'KeyType': 'NotGame', 'val': 'Pokemon', 'key': 11, 'FId': '', 'SId': '55b61752-b4b2-4437-8eba-a9f21cc14b6f', 'TId': '2794188f-92c7-4c8b-bf7b-019e8bb07e8b' },
    {
      Id: "",
      ChName: "手绘",
      EnName: "Sketch",
      KeyType: "",
      key: 12,
      index: "0-2-0",
      FId: "dee8e93d-bf0d-46d7-a817-45db58756940",
      SId: "7c8a9434-60b1-4f21-b2ee-6bfd654d5d47",
      TId: "5f75ac02-f9b6-4015-b931-76a584fc1827"
    },
    {
      Id: "",
      ChName: "娱乐",
      EnName: "ENT",
      KeyType: "",
      key: 12,
      index: "0-2-0",
      FId: "dee8e93d-bf0d-46d7-a817-45db58756940",
      SId: "5bbcb634-3298-4655-9eda-67ab2d39afae",
      TId: "385b99fb-8d90-4cef-8e3e-b70d1a1c6235"
    }
  ],
  SortBtns: [
    /**
     * Sort 排序类型
     * **/
    {
      label: "最先结束",
      val: "EffectiveTimeStamp",
      sortType: "ASC",
      active: "primary"
    },
    {
      label: "最晚结束",
      val: "EffectiveTimeStamp",
      sortType: "DESC",
      active: "default"
    },
    {
      label: "最新发布",
      val: "LastOnTimeStamp",
      sortType: "DESC",
      active: "default"
    },
    {
      label: "最早发布",
      val: "LastOnTimeStamp",
      sortType: "ASC",
      active: "default"
    },
    { label: "最低价格", val: "Price", sortType: "ASC", active: "default" },
    { label: "最高价格", val: "Price", sortType: "DESC", active: "default" }
  ],
  placeHolder: {
    CardCondition: {
      ch: "针对卡品做简短描述，特别非评级类卡片",
      en: "Make a brief description of card products"
    },
    LimitQuantity: {
      ch: "请输入数字",
      en: "Please enter a number"
    },
    CardNumber: {
      ch: "请输入数字编号",
      en: "Please enter a numeric number"
    }
  },
  rookiePatch(rookie, patch, auto) {
    var obj = rookie + "-" + patch + "-" + auto;
    var filter = {
      "Yes-Patch-Yes": "RPA",
      "Yes-Patch-No": "RC Patch",
      "No-Patch-Yes": "PA",
      "No-Patch-No": "Patch",

      "Yes-Jersey-Yes": "RJA",
      "Yes-Jersey-No": "RC JSY",
      "No-Jersey-Yes": "JSY Auto",
      "No-Jersey-No": "JSY",

      "Yes-None-Yes": "RC Auto",
      "Yes-None-No": "RC",
      "No-None-No": "",
      "No-None-Yes": "Auto"
    };
    var rpa = filter[obj] || "";
    return rpa;
  },
  PropertySelectShow: [
    "Sports",
    "Year",
    "Manufacturer",
    "Version",
    "GameComic",
    "Version"
  ] /* 属性列表显示下拉选择的对象 */,
  cardType: {
    level: [
      "4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de",
      "5bbcb634-3298-4655-9eda-67ab2d39afae",
      "55b61752-b4b2-4437-8eba-a9f21cc14b6f",
      "7c8a9434-60b1-4f21-b2ee-6bfd654d5d47",
      "d634f061-a23c-42ba-88f6-91052f315579"
    ], //ID: "球星卡"、"娱乐卡"、"TCG"、"手绘"、"集卡社"
    getType: function(cname) {
      var type = ["Singles", "Packs", "Boxes", "Cases", "Lots"],
        type2 = [
          "Trading Card Singles",
          "Sealed Trading Card Packs",
          "Sealed Trading Card Boxes",
          "Sealed Trading Card Cases",
          "Trading Card Lots"
        ], //卡片类型：单卡、包、盒、箱、多卡
        type3 = [
          "单卡",
          "未拆封卡（包）",
          "未拆封卡（盒）",
          "未拆封卡（箱）",
          "多卡"
        ]; //卡片类型：单卡、包、盒、箱、多卡
      var tt =
        type2.indexOf(cname) > -1
          ? type[type2.indexOf(cname)]
          : type[type3.indexOf(cname)];
      return tt;
    }
  },
  solrTitle(cardType, name, ttType) {
    // console.log('UtilsolrTitle1', cardType, name, st, key);
    var st = [],
      key = null;
    switch (cardType) {
      case this.cardType["level"][0]: //"球星卡"
        if (ttType == "Singles") {
          //'StoreName','CardNickname',
          st = ["Year", "Manufacturer", "Set", "Player", "Rookie", "CustomVal"];
        } else if (
          ttType == "Packs" ||
          ttType == "Boxes" ||
          ttType == "Cases"
        ) {
          st = [
            "Year",
            "Manufacturer",
            "Set",
            "Version",
            "Sports",
            "CustomVal"
          ];
        } else {
          st = ["CustomVal"];
        }
        break;
      case this.cardType["level"][1]: //"娱乐卡"
        if (ttType == "Singles") {
          st = ["Year", "Franchise", "Manufacturer", "Artist", "CustomVal"];
        } else if (
          ttType == "Packs" ||
          ttType == "Boxes" ||
          ttType == "Cases"
        ) {
          st = ["Franchise", "Manufacturer", "CustomVal"];
        } else {
          st = ["CustomVal"];
        }
        break;
      case this.cardType["level"][2]: //"TCG"
        if (ttType == "Singles") {
          st = ["Year", "GameComic", "Set", "CardName", "Version", "CustomVal"];
        } else if (
          ttType == "Packs" ||
          ttType == "Boxes" ||
          ttType == "Cases"
        ) {
          st = ["GameComic", "Manufacturer", "Set", "CustomVal"];
        } else {
          st = ["CustomVal"];
        }
        //_solrTitle = _GameComicReal + "|" + _CardManufacturerReal + "|" + _SetReal + "|" + _CustomVal;
        break;
      case this.cardType["level"][3]: //"手绘"
        if (ttType == "Singles") {
          st = [
            "Year",
            "Franchise",
            "Manufacturer",
            "Character",
            "Artist",
            "CustomVal"
          ];
        } else {
          st = ["CustomVal"];
        }
        break;
      case this.cardType["level"][4]: //"集卡社"
        if (ttType == "Singles") {
          st = ["Franchise", "Set", "Round", "Rarity", "CardName", "CustomVal"];
        } else if (
          ttType == "Packs" ||
          ttType == "Boxes" ||
          ttType == "Cases"
        ) {
          st = ["Franchise", "Set", "Round", "CustomVal"];
        } else {
          st = ["CustomVal"];
        }
        break;
    }
    if (name) {
      st.filter(function(obj, k) {
        if (obj == name) {
          key = k;
        }
      });
    }
    //console.log('UtilsolrTitle',cardType, name, st,key);
    return key || st;
  },
  arrayToQueryString: function(array_in) {
    //数组转换为URL编码
    var out = new Array();
    console.log("array_in:", array_in);
    for (var key in array_in) {
      out.push(key + "=" + array_in[key]);
    }
    out = out.join("&");

    //console.log("arrayToQueryString:", out);
    return encodeURIComponent(out);
  },
  jsonEncode(json, jsonList, fun) {
    //json URL编码
    //console.log("jsonEncode:", json);
    var _json = {};
    jsonList.map(function(obj, key) {
      var ctlName = obj["ControlName"];
      //console.log(ctlName, obj['ControlType'])
      if (obj["ControlType"] == "combox-more") {
        var ctlValue = "",
          ctlNameArr = obj["ControlName"] + "Arr";
        if (json[ctlNameArr] && json[ctlNameArr].length) {
          json[ctlNameArr].map(function(o, k) {
            if (o) {
              ctlValue += (k > 0 ? "," : "") + o;
            }
          });
          //_json[ctlName] = ctlValue; //使用_json去除xxxArr
          json[ctlName] = ctlValue;
        }
      }
      //else {
      //    _json[ctlName] = json[ctlName];
      //}
    });
    var uriCode = encodeURIComponent(JSON.stringify(json));
    //console.log("jsonEncode-uriCode:", uriCode);
    //new fun(uriCode)
    return uriCode;
  },
  resetProperties: function(categoryProperties) {
    //属性重组 3级分类下的属性列表
    var _tempPropertyJson = {};
    var _PropertyList = [];
    categoryProperties.map(function(obj, key) {
      _tempPropertyJson[obj["Property"]["ControlName"]] = "";
      _PropertyList[key] = {
        ControlType: obj["ControlType"],
        IsRequired: obj["IsRequired"],
        IsScreen: obj["IsScreen"],
        Show: obj["IsRequired"].length <= 1 ? true : false,
        ...obj["Property"]
      };
    });
    return {
      tempPropertyJson: _tempPropertyJson,
      propertyList: _PropertyList
    };
  },
  resetCategory:function (Category, haveAll = true) {
    //分类结构重组 [{'id':1,'label':'卡片','children':[{'id':1,'label':'影视卡','children':[....]}]}]
    var ctg = [];
    Category.map(function (o, k) {
        var f = o['FirstCategory']['Category'];
        var label = {
            "id": f['_id'],
            "label": f['ChName'], "ChName": f['ChName'], 'EnName': f['EnName'],
            "level":1,
            "children": []
        };
        ctg.push(label);
        o['FirstCategory']['SecondCategories'].map(function (oo, kk) {
            var ooData = {
                "id": oo['Category']['_id'], "fId": f['_id'],
                "label": oo['Category']['ChName'], "ChName": oo['Category']['ChName'], 'EnName': oo['Category']['EnName'],
                'FCName': f['ChName'], 'FEName': f['EnName'],
                "level": 2,
                "children": []
            };
            ctg[k]['children'].push(ooData);
            oo['ThirdCategories'].map(function (ooo, kkk) {
                var oooData = {
                    "id": ooo['Category']['_id'], "fId": f['_id'], "sId": oo['Category']['_id'],
                    "label": ooo['Category']['ChName'],"ChName": ooo['Category']['ChName'], 'EnName': ooo['Category']['EnName'],
                    'FCName': f['ChName'], 'FEName': f['EnName'], 'SCName': oo['Category']['ChName'], 'SEName': oo['Category']['EnName'],
                    'Properties': ooo['CategoryProperties'],
                    "level": 3,
                    "children": []
                };
                if (!haveAll) {
                    if (ooo['Category']['EnName'] != "All") {
                        ctg[k]['children'][kk]['children'].push(oooData);
                    }
                } else {
                    ctg[k]['children'][kk]['children'].push(oooData);
                }
            });
        });
    });
    return ctg;
  },

  setNewDate: function(val) {
    /**
     *  把时间格式转换成yyyy/mm/dd
     *  为了适配Safari浏览器 safari浏览器new date()只能用yyyy/mm/dd的形式，不然就报错
     * **/
    var userAgent = navigator.userAgent.toLowerCase();
    //console.log(userAgent)
    //console.log(userAgent.indexOf('safari'))
    if (userAgent.indexOf("safari") > -1) {
      // console.log(val)
      val = val.replace(/\-/g, "/");
      // console.log('val',val)
    }
    return val;
  },
  getTime: function(fmt, unix) {
    /**
     *  fmt:"yyyy-MM-dd" "yyyy-MM-dd HH:mm:ss"
     *  unix: time date unix
     * **/
    var date = unix ? new Date(unix) : new Date();
    var o = {
      "M+": date.getMonth() + 1, //月份
      "d+": date.getDate(), //日
      "H+": date.getHours(), //小时
      "m+": date.getMinutes(), //分
      "s+": date.getSeconds(), //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      S: date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    return fmt;
  },
  areaReconfig: function(data) {
    //省直辖市 重组
    var area = [],
      AG = [],
      HK = [],
      LS = [],
      TZ = [];
    data.map(function(obj, key) {
      switch (obj.ECode) {
        case "A-G":
          AG.push(obj);
          break;
        case "H-K":
          HK.push(obj);
          break;
        case "L-S":
          LS.push(obj);
          break;
        case "T-Z":
          TZ.push(obj);
          break;
      }
    });
    area = [
      {
        name: "A-G",
        area: [...AG]
      },
      {
        name: "H-K",
        area: [...HK]
      },
      {
        name: "L-S",
        area: [...LS]
      },
      {
        name: "T-Z",
        area: [...TZ]
      }
    ];
    return area;
  },
  getQueryVariable: function(variable) {
    //获取URL参数
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  },
  rule: function(type) {
    var _r = {
      formRule: {
        //自定义
        CustomVal: [
          // {
          //   message: "Cannot input Chinese characters",
          //   trigger: 'blur'
          // }, //不能输入汉字
          {
            validator: function(rule, value, callback) {
              var val = value.toLowerCase();
              if (/[\u4E00-\u9FA5]/g.test(value) && value) {
                callback(new Error("Cannot input Chinese characters")); //不能输入汉字
              } else if (value && val.indexOf("not") > -1) {
                callback(new Error("Definition Title cannot contain:not"));
              } else {
                // 验证通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],

        //表单验证
        // Sports: [{
        //   required: true,
        //   message: 'Please select a joint',
        //   trigger: ['change', 'blur']
        // }], //请选择运动类型
        // Graded: [{
        //   required: true,
        //   message: 'Please select whether to rate',
        //   trigger: ['change', 'blur']
        // }], //请选择是否评级
        // ProfessionalGrader: [{
        //   required: true,
        //   message: 'Please select a rating company',
        //   trigger: ['change', 'blur']
        // }], //请选择评级公司
        // Grade: [{
        //   required: true,
        //   message: 'Please select a rating score',
        //   trigger: ['change', 'blur']
        // }], //请选择评级分数
        CertificationNumber: [
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "Please enter the correct certificate number",
            trigger: ["change", "blur"]
          }, //请输入正确的证书编号
          {
            max: 20,
            message: "Length less than 20 characters",
            trigger: "blur"
          } //长度20个字符以内
        ],
        CardCondition: [
          {
            max: 20,
            message: "Length less than 20 characters",
            trigger: ["change", "blur"]
          }
        ], //品相    长度20个字符以内
        // CardManufacturer: [{
        //   required: true,
        //   message: 'Please select the hairstyle manufacturer',
        //   trigger: ['change', 'blur']
        // }], //请选择发型厂商
        // Set: [{
        //   required: true,
        //   message: 'Please select set series',
        //   trigger: ['change', 'blur']
        // }], //请选择套系列
        // Limited: [{
        //   required: true,
        //   message: 'Please select whether to limit',
        //   trigger: ['change', 'blur']
        // }], //请选择是否限量
        LimitQuantity: [
          {
            pattern: /^[1-9]\d*$/,
            message: "Please fill in the limited quantity",
            trigger: ["blur", "change"]
          }, //请填写限量数量
          {
            min: 1,
            max: 99999,
            message: "The limited quantity cannot exceed 99999",
            trigger: "blur"
          } //限量数量不可超过99999
        ],
        // Player: [{
        //   required: true,
        //   message: "Please select the athlete's name",
        //   trigger: ['change', 'blur']
        // }], //请选择运动员名字
        // ParallelVariety: [{
        //   required: true,
        //   message: 'Please select a variety',
        //   trigger: ['change', 'blur']
        // }], //请选择品种
        // Team: [{
        //   required: true,
        //   message: 'Please select a team',
        //   trigger: ['change', 'blur']
        // }], //请选择球队
        // Autographed: [{
        //   required: true,
        //   message: 'Please choose whether to sign in person',
        //   trigger: ['change', 'blur']
        // }], //请选择是否亲笔签名

        // Rookie: [{
        //   required: true,
        //   message: 'Please choose',
        //   trigger: ['change', 'blur']
        // }],
        // PatchJersey: [{
        //   required: true,
        //   message: 'Please choose',
        //   trigger: ['change', 'blur']
        // }],
        // Auto: [{
        //   required: true,
        //   message: 'Please choose',
        //   trigger: ['change', 'blur']
        // }],

        //CardsQuantity: [{required: true,pattern: /^[1-9]\d*$/,message: 'Please fill in the number of cards',trigger: ['change', 'blur']}, {min: 1,max: 99999,message: 'The number of pieces cannot exceed 99999',trigger: 'blur'}], /*请填写卡片数 /片数不可超过99999*/
        CardName: [
          {
            max: 20,
            message: "Length less than 20 characters",
            trigger: ["change", "blur"]
          }
        ], //卡片名称      长度20个字符以内
        CardNumber: [
          {
            pattern: /^[\-#A-Za-z0-9]+$/,
            message: "Please enter the correct card number",
            trigger: ["change", "blur"]
          }, //请输入正确的卡片编号
          {
            max: 20,
            message: "Length less than 20 characters",
            trigger: "blur"
          }
        ], //卡片编号   长度20个字符以内

        //
        // Franchise: [{
        //   required: true,
        //   message: 'Please select a movie name',
        //   trigger: ['change', 'blur']
        // }], //请选择影视名称
        // CardType: [{
        //   required: true,
        //   message: 'Please select card type',
        //   trigger: ['change', 'blur']
        // }], //请选择卡片类型
        // GameComic: [{
        //   required: true,
        //   message: 'Please select a game name',
        //   trigger: ['change', 'blur']
        // }], //请选择游戏名称
        // Finish: [{
        //   required: true,
        //   message: 'Please select machining',
        //   trigger: ['change', 'blur']
        // }], //请选择加工
        // Rarity: [{
        //   required: true,
        //   message: 'Please select rarity',
        //   trigger: ['change', 'blur']
        // }], //请选择稀有程度
        // CreatureMonsterTypeArr: [{
        //   required: true,
        //   message: 'Please select monster type',
        //   trigger: ['change', 'blur']
        // }], //请选择怪物类型

        //定价
        ByWay: [
          {
            required: true,
            pattern: /^[1-9]+$/,
            message: "Please select pricing method",
            trigger: ["change", "blur"]
          }
        ], //请选择定价方法
        // Price: [{
        //   required: true,
        //   // pattern: /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]$)/,
        //   message: 'Please fill in the price',
        //   trigger: ['change', 'blur']
        // }], //请填写价格
        QuantitySold: [
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            message: i18n.t("tips.plsFillQuantity"),//"Please fill in the quantity",
            trigger: ["change", "blur"]
          }
        ], //请填写数量
        EffectiveDay: [
          {
            required: true,
            message: i18n.t("tips.plsSelDuration"),//"Please select duration",
            trigger: ["change", "blur"]
          }
        ], //请选择拍卖持续时间
        Bargain: [
          {
            required: true,
            message: i18n.t("tips.plsSelBargaining"),//"Please select bargaining",
            trigger: ["change", "blur"]
          }
        ], //请选择议价
        IsLimit: [
          {
            required: true,
            message: i18n.t("tips.plsSelRestriction"),//"Please select purchase restriction",
            trigger: ["change", "blur"]
          }
        ], //请选择限购
        LimitNumber: [
          {
            required: true,
            message: i18n.t("tips.plsFillRestricted"),//"Please fill in the restricted quantity",
            trigger: ["change", "blur"]
          }
        ], //请填写限购数量
        // LPrice: [{
        //   required: true,
        //   message: 'Please fill in the lowest quotation amount',
        //   trigger: ['change', 'blur']
        // }], //请填写最低报价金额
        // HPrice: [{
        //   required: true,
        //   message: 'Please fill in the amount of automatically accepted quotation',
        //   trigger: 'change'
        // }], //请填写自动接受报价金额
        ReleaseType: [
          {
            required: true,
            message: i18n.t("tips.plsSelStartTime"),//"Please select a start time",
            trigger: ["change", "blur"]
          }
        ], //请选择开始时间
        LastOnTime: [
          {
            required: true,
            message: i18n.t("tips.plsSelStartTime"),//"Please select a start time",
            trigger: ["change", "blur"]
          }
        ],
        DepositNum: [
          {
            required: true,
            message: i18n.t("tips.plsEnter"),
            trigger: ["change", "blur"]
          }, //请填写限量数量
          {
            validator: function(rule, value, callback) {
              if (parseFloat(value)>10000) {
                callback(new Error(i18n.t("tips.CannotExceed",[10000])));//"Cannot exceed 10000",
              } else {
                // 验证通过
                callback();
              }
            },
            trigger: ["change", "blur"]
          } //限
        ], //请输入
        CreditNum: [
          {
            required: true,
            message: i18n.t("tips.plsEnter"),
            trigger: ["change", "blur"]
          },{
            validator: function(rule, value, callback) {
              if (parseFloat(value)>10000000) {
                callback(new Error(i18n.t("tips.CannotExceed",[10000000])));//"Cannot exceed 10000000",
              } else {
                // 验证通过
                callback();
              }
            },
            trigger: ["change", "blur"]
          } //限
        ], //请输入
        IsDeposit: [
          {
            required: true,
            pattern: /^[0-9]+$/,
            message: i18n.t("tips.plsEnter"),
            trigger: ["change", "blur"]
          }
        ] //请选择
        //Version  Features League CardSize CardCondition ：false
      },
      notnull: [
        {
          required: true,
          message: i18n.t("tips.CannotBeBlank"),//"Required item cannot be blank",
          trigger: ["change", "blur"]
        }
      ], //必填项不能为空
      countLength: function(text) {
        var text = text.trim();
        //计算字符串长度，汉字+2
        var len = 0,
          code = 0;
        for (var i = 0; i < text.length; i++) {
          code = text.charCodeAt(i);
          //判断Unicode，汉字和普通字节
          if (code >= 0 && code <= 127) {
            //普通语言的编码值<=127
            len += 1;
          } else {
            len += 2;
          }
        }
        return len;
      }
    };
    return type ? _r[type] : _r;
  }
};
export default util;



// WEBPACK FOOTER //
// ./src/common/util.js